import { HelpSection } from "./help-container";
import { LinkTiles } from "../tile/tile";
import { RelatedItemType } from "../constants";

export function HelpRelatedItems(props) {
    const handleClick = (tile) => {
        if (tile.External) {
            window.open(props.Id, "_blank");
        } else {
            props.OnClick(tile.Id, tile.Type);
        }
    };

    const getLinks = () => {
        return props.Items.map(item => ({ Id: item.Id, Name: item.Name, Type: item.Type, External: item.Type === RelatedItemType.External })); //DELETE if shifting to tiles for this - pulling descriptions out
    };

    if (!props.Items || props.Items.length === 0) {
        return null;
    }

    return (
        <HelpSection
            Theme={props.Theme}
            Heading={"See also"}>
            <LinkTiles
                Tiles={getLinks()}
                Theme={props.Theme}
                OnClick={handleClick} />
        </HelpSection>
    );
}